<template>
    <div>
        <!-- {{ getIdJob }} -->
        <h4 style="font-weight:100" class="font-en mt-0 mb-0">
            <b-link
                :to="{
                    name: 'IC Service'
                }"
                class="mr-2"
            >
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </b-link>
            Solution
        </h4>
        <small class="mt-0">Guidelines for solving your problems.</small>
        <div class="mt-3 row">
            <div class="col-md-12">
                <b-card header-bg-variant="dark" header-text-variant="light">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h4 style="font-weight:100;" class="font-en mt-0 mb-0"><i class="fa fa-ticket mr-2" aria-hidden="true"></i>Your Query No. {{ getIdJob }}</h4>
                        <div>
                            <div v-if="getStatus === 'wait' && !EditForm">
                                <b-button class="text-capitalize mt-0 mb-2" @click="changeEditForm" size="sm" variant="info"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>Edit Ticket</b-button>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div v-if="EditForm">
                        <b-row class="my-0">
                            <b-col sm="10">
                                <b-form class="mt-0">
                                    <b-row class="my-0">
                                        <b-col sm="4">
                                            <label><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Topic</label>
                                        </b-col>
                                        <b-col class="font-thai" sm="8">{{ getToppicJob }}</b-col>
                                    </b-row>
                                    <b-row class="my-0">
                                        <b-col sm="4">
                                            <label><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Catagory</label>
                                        </b-col>
                                        <b-col sm="8">
                                            <b-form-select
                                                :options="optionsSelectProblem"
                                                v-model="formData.typeProblem"
                                                class="font-thai"
                                                autocomplete="off" trim
                                            >
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                    <b-row class="my-0">
                                        <b-col sm="4">
                                            <label><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Email</label>
                                        </b-col>
                                        <b-col sm="8">
                                            <b-form-group
                                                description="Please enter a valid email address so our staff can reach you."
                                            >
                                                <b-form-input
                                                    class="font-thai"
                                                    type="email"
                                                    placeholder="Enter email"
                                                    autocomplete="off" trim
                                                    v-model="formData.mailContact"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="my-0">
                                        <b-col sm="4">
                                            <label><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Phone number</label>
                                        </b-col>
                                        <b-col sm="8">
                                            <b-form-group
                                                invalid-feedback="Bad Mobile Phone format"
                                                description="Please enter your telephone number ex: 0800547169"
                                            >
                                                <b-form-input
                                                    size="sm"
                                                    class="font-thai"
                                                    maxlength="10"
                                                    type="text"
                                                    placeholder="Enter Phone number"
                                                    autocomplete="off" trim
                                                    v-model="formData.phoneContact"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="my-0">
                                        <b-col sm="4"></b-col>
                                        <b-col sm="8">
                                            <b-button block class="text-capitalize mb-2" @click="updateTicketData(getIdJob)" size="sm" variant="success"><i class="fa fa-paper-plane" aria-hidden="true"></i>Submit</b-button>
                                            <b-button block class="text-capitalize mb-2" @click="EditForm = !EditForm" size="sm" variant="warning"><i class="fa fa-reply" aria-hidden="true"></i>Back</b-button>
                                            <hr>
                                            <b-button @click="cancelCase(getIdJob)" block class="text-capitalize" size="sm" variant="danger">
                                                <i class="fa fa-times" aria-hidden="true"></i>Delete Query
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-else>
                        <!-- 
                            <p style="font-size:0.95rem;" class="mb-0 font-thai">
                                <span class=""><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Topic : {{ getToppicJob }}</span>
                            </p>
                            <p style="font-size:0.95rem;" class="mt-2 mb-2 font-thai">
                                <span class=""><i class="fa fa-comments" aria-hidden="true"></i>Comment :</span>
                            </p> 
                        -->
                        <div v-for="(item, index) in dataComment" :key="index">
                            <b-card
                                class="mb-2 mt-0"
                                :class="{ 'bordercolorCustom' : getOwner !== item.user , 'bg-light' : getOwner === item.user }"
                            >
                                <b-card-text >
                                    <b-media>
                                        <template v-slot:aside>
                                            <img v-if="getOwner === item.user" class="rounded" src="@/assets/img/icon_std.png" width="50" alt="icon_std">
                                            <img v-else class="rounded" src="@/assets/img/icon_staff.png" width="45" alt="icon_std">
                                        </template>
                                        <!-- 
                                            <h6 v-if="getOwner === item.user" class="mt-0 mb-0 text-capitalize">{{ $keycloak.fullName }} : </h6>
                                            <h6 v-else class="mt-0 mb-0 text-capitalize">[ Support Team ] {{ item.user }} : </h6> 
                                        -->
                                        <p  style="font-size:1.2rem;" class="mt-0 mb-1 font-thai" v-if="index === 0">Topic : {{ getToppicJob }}</p>
                                        <h6 v-if="getOwner === item.user" class="mt-0 mb-0 text-capitalize font-thai"><i v-if="index === 0" class="fa fa-user"></i>{{ $keycloak.fullName }}</h6>
                                        <h6 v-else class="mt-0 mb-0 text-capitalize">[ Support Team ] {{ item.user }} : </h6>
                                        <small style="font-size:0.7rem;" class="text-small font-en">{{ moment(item.created_at).format('LLL') }}</small>
                                        <hr>
                                        <p style="font-size:0.85rem;" class="mt-2 mb-0 font-thai text-muted">
                                            <i :class="{ 'fa fa-question': getOwner === item.user , 'fa fa-reply' : getOwner !== item.user  }"></i>{{ getOwner === item.user ? 'Question / issue' : `Reply` }}
                                        </p>
                                        <p style="font-size:1rem;" class="mt-1 mb-2 text-justify font-thai">{{ item.message }}</p>
                                        <!-- <froalaView class="font-thai" v-model="item.message"></froalaView> -->
                                        <b-link class="font-weight-bold" style="font-size:0.7rem;" variant="light" v-if="item.upload_file !== '' && item.upload_file !== null" target="_blank" :href="item.upload_file" >
                                            <i v-if="getFileExtension(item.upload_file) === 'pdf'" class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                            <i v-else-if="getFileExtension(item.upload_file) === 'docx'" class="fa fa-file-word-o" aria-hidden="true"></i>
                                            <i v-else-if="getFileExtension(item.upload_file) === 'png' || getFileExtension(item.upload_file) === 'jpg' || getFileExtension(item.upload_file) === 'jpeg'" class="fa fa-picture-o" aria-hidden="true"></i>
                                            <i v-else class="fa fa fa-file" aria-hidden="true"></i>
                                            View file .{{ getFileExtension(item.upload_file) }}<br>
                                        </b-link>
                                        <div v-if="getFileExtension(item.upload_file) === 'png' || getFileExtension(item.upload_file) === 'jpg' || getFileExtension(item.upload_file) === 'jpeg'">
                                            <b-img width="50" thumbnail :src="item.upload_file" alt=""></b-img>
                                        </div>
                                    </b-media>
                                </b-card-text>
                            </b-card>
                        </div>
                        <!-- success form -->
                        <div v-if="getStatus === 'success'">
                            <div v-if="getTicketpoint !== null">
                                <p style="font-size:1.2rem;" class="mt-5 mb-1 font-thai">
                                    <i class="fa fa-chevron-circle-right mr-1" aria-hidden="true"></i>Point :
                                    <span v-if="getTicketpoint !== null"> <span v-for="(item, star) in getTicketpoint" :key="star"><i class="fa fa-star fa-lg mr-2 text-warning" aria-hidden="true"></i></span></span>
                                </p>
                                <!-- <p style="font-size:1.2rem;" class="mt-3 mb-3 font-thai">
                                    <span class=""><i class="fa fa-chevron-circle-right mr-1" aria-hidden="true"></i>suggestion : {{ getTicketcomment }}</span>
                                </p> -->
                                <h4 style="font-weight:100;" class="mt-3 mb-0 font-thai">
                                    <i class="fa fa-chevron-circle-right mr-1" aria-hidden="true"></i>Suggestion : {{ getTicketcomment }}
                                    <!-- <froalaView class="mt-2 ml-5 mb-3 font-thai" v-model="getTicketcomment"></froalaView> -->
                                </h4>
                            </div>
                            <div v-else>
                                <b-form-input hidden v-model="formVoteData.idJob"></b-form-input>
                                <label class="text-dark font-thai mt-2 mb-2"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Suggestion (if any)</label>
                                <b-form-textarea
                                    v-model="formVoteData.suggestion"
                                    class="font-thai"
                                    placeholder="Describe in detail"
                                    rows="3"
                                    max-rows="6"
                                ></b-form-textarea>
                                <!-- <froala :config="config" v-model="formVoteData.suggestion"></froala> -->
                                <label class="text-dark font-thai mt-2 mb-0"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Point</label>
                                <br>
                                <fieldset class="rating">
                                    <input type="radio" id="star5" name="rating" value="5" /><label class = "full" for="star5" title="5 point"></label>
                                    <input type="radio" id="star4" name="rating" value="4" /><label class = "full" for="star4" title="4 point"></label>
                                    <input type="radio" id="star3" name="rating" value="3" /><label class = "full" for="star3" title="3 point"></label>
                                    <input type="radio" id="star2" name="rating" value="2" /><label class = "full" for="star2" title="2 point"></label>
                                    <input type="radio" id="star1" name="rating" value="1" /><label class = "full" for="star1" title="1 point"></label>
                                </fieldset>
                                <b-button class="text-capitalize" @click="addVoteTicket" size="sm" block variant="success"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i>Submit Vote Ticket / close</b-button>
                            </div>
                        </div>
                        <!-- wait form -->
                        <div v-if="getStatus === 'wait' || !formUiComment">
                            <b-form-input hidden v-model="formCommentData.idJob"></b-form-input>
                            <label class="text-dark font-thai mt-0 mb-0"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Question / issue</label>
                            <!-- error chk -->
                            <b-alert v-for="msg in errorMsgs" :key="msg.timestamp" show variant="danger" dismissible>
                                Check : File size upload image max size 10Mb or massege push
                            </b-alert>
                            <!-- <froala :config="config" v-model="formCommentData.Comment"></froala> -->
                            <b-form-textarea
                                v-model="formCommentData.Comment"
                                class="font-thai"
                                placeholder=""
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea> 
                            <label class="text-dark font-thai mt-2 mb-0"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Attachments (if any)</label>
                            <b-form-group>
                                <b-form-file plain v-model="formCommentData.file" size="sm"></b-form-file>
                                <label style="font-size:0.7rem;" class="text-dark font-thai mt-0 mb-0">*** Screen-shot of issue (showing the problem, disconnects or failed connections, etc.) <strong>(max 10Mb total)</strong></label>
                            </b-form-group>
                            <b-button :disabled="!isFormValid" @click="addCommentRequest" size="sm" class="mt-2 mb-2 text-capitalize" block variant="info"><i class="fa fa-paper-plane" aria-hidden="true"></i>Submit</b-button>
                            <b-button v-if="getStatus !== 'wait'" @click="formUiComment = !formUiComment" size="sm" class="mt-2 mb-2 text-capitalize" block variant="warning"><i class="fa fa-reply mr-1"></i>Back</b-button> 
                        </div>
                        <!-- inprogress form -->
                        <div v-if="getStatus === 'accept' && formUiComment">
                            <!-- formUiVote -->
                            <div v-if="formUiVote">
                                <b-form-input hidden v-model="formVoteData.idJob"></b-form-input>
                                <label class="text-dark font-thai mt-2 mb-2"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Suggestion (if any)</label>
                                <b-form-textarea
                                    v-model="formVoteData.suggestion"
                                    class="font-thai"
                                    placeholder=""
                                    rows="3"
                                    max-rows="6"
                                ></b-form-textarea> 
                                <!-- <froala :config="config" v-model="formVoteData.suggestion"></froala> -->
                                <label class="text-dark font-thai mt-2 mb-0"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Point</label>
                                <br>
                                <fieldset class="rating">
                                    <input type="radio" id="star5" name="rating" value="5" /><label class = "full" for="star5" title="5 point"></label>
                                    <input type="radio" id="star4" name="rating" value="4" /><label class = "full" for="star4" title="4 point"></label>
                                    <input type="radio" id="star3" name="rating" value="3" /><label class = "full" for="star3" title="3 point"></label>
                                    <input type="radio" id="star2" name="rating" value="2" /><label class = "full" for="star2" title="2 point"></label>
                                    <input type="radio" id="star1" name="rating" value="1" /><label class = "full" for="star1" title="1 point"></label>
                                </fieldset>
                                <b-button class="text-capitalize mb-2" @click="addCloseTicket" size="sm" block variant="success"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i>Submit Vote Ticket / close</b-button>
                                <b-button size="sm" @click="CloseFormVote" class="text-capitalize" block variant="warning"><i class="fa fa-reply mr-1"></i>Back</b-button>
                            </div>
                            <!-- formUiVote -->
                            <!-- BtnControll -->
                            <div v-else>
                                <hr>
                                <h4 class="mt-3 mb-2 text-danger text-capitalize font-weight-bold"><i class="fa fa-chevron-circle-right mr-1" aria-hidden="true"></i>Is your problem resolved ?</h4>
                                <b-button style="font-size:1.2rem;" class="text-capitalize" @click="openFormVote" block variant="success"><i class="fa fa-check mr-1" aria-hidden="true"></i>Yes</b-button>
                                <b-button style="font-size:1.2rem;" class="text-capitalize" @click="formUiComment = !formUiComment" block variant="danger"><i class="fa fa-times mr-1" aria-hidden="true"></i>No</b-button>
                                <!-- 
                                    <b-button class="text-capitalize mb-2" @click="formUiComment = !formUiComment" size="sm" block variant="info"><i class="fa fa-comments" aria-hidden="true"></i>Report additional problems.</b-button>
                                    <b-button class="text-capitalize" @click="openFormVote" size="sm" block variant="success"><i class="fa fa-check-square-o" aria-hidden="true"></i>Your problem has been resolved.</b-button>
                                -->
                            </div>
                            <!-- BtnControll -->
                        </div>
                    </div>
                </b-card>
                <b-media>
                    <h6 style="font-weight:100" class="text-capitalize mt-0 mb-1 font-en"><i class="fa fa-phone-square" aria-hidden="true"></i> For more inquiries, please contact :</h6>
                    <b-alert show variant="infox">
                        <p style="font-size:0.8rem" class="text-muted font-en">The Admission Office<br>Tel. 0-2700-5000 ext. 4344-4347</p>
                        <p style="font-size:0.8rem" class="text-muted font-en">The Registrar Unit<br>Tel. 0-2700-5000 ext. 4325, 4330-4334, 4336 and 4342</p>
                        <p style="font-size:0.8rem" class="text-muted font-en">The Educational Affairs Section<br>Tel. 0-2700-5000 ext. 4311, 4314 and 4318</p>
                        <p style="font-size:0.8rem" class="text-muted font-en">The Office of Student Affairs<br>Tel. 0-2700-5000 ext. 1115 and 1210</p>
                        <p style="font-size:0.8rem" class="text-muted font-en">The Finance & Accounting Section<br>Tel. 0-2700-5000 ext. 1020, 1322 and 1231</p>
                        <p style="font-size:0.8rem" class="text-muted font-en">Science Division Office<br>Tel. 0-2700-5000 ext. 3517</p>
                        <p style="font-size:0.8rem" class="text-muted mb-0 mt-0 text-right"><small>Updated March 23, 2020(2.45 p.m.)</small></p>
                    </b-alert>
                </b-media>
                <!-- staff solution -->
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .bordercolorCustom{ border-left: 10px solid #8cc1f9; border-right: 3px solid #8cc1f9; }
    .font-thai { font-family: 'Kanit', sans-serif; font-weight: 100; font-size: 0.9rem; }
    .font-en { font-family: 'Rubik', sans-serif; }
    .alert-infox { background-color: #eaeaea; color: #000000; }
    // 
    #style-5::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        background-color: #ffffff;
    }
    #style-5::-webkit-scrollbar
    {
        width: 3px;
        background-color: #F5F5F5;
    }
    #style-5::-webkit-scrollbar-thumb
    {
        background-color: #bdbdbd;
        border: 1px solid #bdbdbd;
    }
    // 34597b 3578E5
    .alert-infomsg {  background-color: #34597b; color: #ffffff; }
    // rating vote
    /****** Style Star Rating Widget *****/
    .rating { 
        border: none;
        float: left;
    }
    .rating > input { display: none; } 
    .rating > label:before { 
        margin: 5px;
        font-size: 3em;
        font-family: FontAwesome;
        display: inline-block;
        content: "\f005";
    }
    .rating > .half:before { 
        content: "\f089";
        position: absolute;
    }
    .rating > label { 
        color: #ddd; 
        float: right; 
    }
    /***** CSS Magic to Highlight Stars on Hover *****/
    .rating > input:checked ~ label, /* show gold star when clicked */
    .rating:not(:checked) > label:hover, /* hover current star */
    .rating:not(:checked) > label:hover ~ label {  color: #FFD700;  } /* hover previous stars in list */
    .rating > input:checked + label:hover, /* hover current star when changing rating */
    .rating > input:checked ~ label:hover,
    .rating > label:hover ~ input:checked ~ label, /* lighten current selection */
    .rating > input:checked ~ label:hover ~ label {  color: #FFED85;  } 
</style>

<script>
    // import VueFroala from 'vue-froala-wysiwyg';
    const formProblem = {
        titleProblem:'',
        descriptionProblem:'',
        typeProblem:'',
        phoneContact:'',
        mailContact:'',
    }
    const formComment = {
        idJob:'',
        Comment:'',
        file:null,
    }
    const formVote = {
        suggestion:'',
        idJob:'',
    }
    export default {
        data() {
            return {
                errorMsgs: [],
                // config: {
                //     imageUpload: true,
                //     imageMaxSize: 1024 * 1024 * 1,
                //     autoDestroy: true,
                //     attribution: false,
                //     toolbarButtons : {
                //         'moreText': {
                //             'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
                //         },
                //         'moreParagraph': {
                //             'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
                //         },
                //         'moreRich': {
                //             'buttons': ['insertLink', 'insertImage', 'insertVideo', 'insertTable','specialCharacters', 'embedly'],
                //             'buttonsVisible': 6
                //         },
                //         'moreMisc': {
                //             'buttons': ['undo', 'redo', 'help'],
                //             'align': 'right',
                //             'buttonsVisible': 3
                //         }
                //     },
                //     events: {
                //         "image.beforeUpload": function(files) {
                //             var editor = this;
                //             if (files.length) {
                //                 // Create a File Reader.
                //                 var reader = new FileReader();
                //                 // Set the reader to insert images when they are loaded.
                //                 reader.onload = function(e) {
                //                 var result = e.target.result;
                //                     editor.image.insert(result, null, null, editor.image.get());
                //                 };
                //                 // Read image as base64.
                //                 reader.readAsDataURL(files[0]);
                //             }
                //             editor.popups.hideAll();
                //             // Stop default upload chain.
                //             return false;
                //         }
                //     }
                // },
                chkCloseTicket:true,
                formUiVote:false,
                formUiComment:true,
                // 
                EditForm:false,
                optionsSelectProblem:[],
                formData: Object.assign({}, formProblem),
                formCommentData: Object.assign({}, formComment),
                formVoteData: Object.assign({}, formVote),
                dataComment:[]
            }
        },
        props: {
            id: { type: Number, default: 0 },
            Staus:{ type: String, default: '' },
            Toppic: { type: String, default: '' },
            description: { type: String, default: '' },
            solution: { type: String, default: '' },
            Phone: { type: String, default: '' },
            Mail: { type: String, default: '' },
            Type: { type: Number, default: '' },
            onwercase: { type: String, default: '' },
            ticketcomment: { type: String, default: '' },
            ticketpoint: { type: Number, default: 0 },
        },
        computed: {
            getIdJob(){
                return this.id !== ''? this.id : 0
            },
            getStatus(){
                return this.Staus !== ''? this.Staus : ''
            },
            getToppicJob(){
                return this.Toppic !== ''? this.Toppic : ''
            },
            getDescriptionJob(){
                return this.description !== ''? this.description : ''
            },
            getSolutionJob(){
                return this.solution !== ''? this.solution : ''
            },
            getPhone(){
                return this.Phone !== ''? this.Phone : ''
            },
            getmail(){
                return this.Mail !== ''? this.Mail : ''
            },
            getType(){
                return this.Type !== ''? this.Type : ''
            },
            getOwner(){
                return this.onwercase !== ''? this.onwercase : ''
            },
            getTicketcomment(){
                return this.ticketcomment !== ''? this.ticketcomment : ''
            },
            getTicketpoint(){
                return this.ticketpoint !== ''? this.ticketpoint : 0
            },
            isFormValid(){
                if (this.formCommentData.Comment !== '') {
                    return true;
                } else {
                    return false;
                }
            },
        },
        mounted(){
            this.formCommentData.idJob = this.getIdJob
            this.formVoteData.idJob = this.getIdJob
            this.optionApi()
            this.getMassegeComment(this.getIdJob)
        },
        methods: {
            openFormVote(){
                this.formUiVote = true
            },
            CloseFormVote(){
                this.formUiVote = false
            },
            async cancelCase(Jobid){
                const response = await this.$http.delete(`/ticket/remove/${Jobid}/`,{
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                this.$router.push('/icservice')
            },
            async optionApi(){
                try {
                    this.optionsSelectProblem = []
                    const res = await this.$http.get('/ticket/type/')
                    this.optionsSelectProblem =  res.data.map(item => {
                        return {
                            'value':item.id,
                            'text':item.detail,
                        }
                    })
                    this.optionsSelectProblem
                } catch (error) {
                    this.output = error
                }
            },
            changeEditForm(){
                this.EditForm = true
                this.formData.descriptionProblem = this.getDescriptionJob
                this.formData.typeProblem = this.getType
                this.formData.phoneContact = this.getPhone
                this.formData.mailContact = this.getmail
            },
            async updateTicketData(Jobid){
                const sendDataProblem = new FormData()
                sendDataProblem.append('message', this.formData.descriptionProblem)
                sendDataProblem.append('ticket_type', this.formData.typeProblem)
                sendDataProblem.append('contact_phone', this.formData.phoneContact)
                sendDataProblem.append('contact_mail', this.formData.mailContact)
                try {
                    const response = await this.$http.patch(`/ticket/updated/${Jobid}/`,
                        sendDataProblem,
                        {
                            headers: { 'Content-Type': 'multipart/form-data' }
                        }
                    )
                    if(response.status === 200){
                        this.$router.push('/icservice')
                        this.EditForm = false
                        // this.id = response.data.id
                        // this.Toppic = response.data.topic
                        // this.description = response.data.message
                        // this.solution = response.data.solution
                        // this.Phone = response.data.contact_phone
                        // this.Mail = response.data.contact_mail
                        // this.Type = response.data.helpdesk_type
                    }
                } catch (error) {
                    this.output = error
                }
            },
            async getMassegeComment(JobidView){
                this.dataComment = []
                try {
                    const res = await this.$http.get(`/ticket/msg/pull/${JobidView}/`)
                    // console.log(res.data)dataComment
                    this.dataComment = res.data.map(item => {
                        return {
                            'id':Number(item.id),
                            'created_at': item.created_at, 
                            'message': item.message,
                            'ticket': item.ticket,
                            'upload_file':item.upload_file,
                            'user':item.user,
                        }
                    })
                    this.scrollToEnd()
                } catch (error) {}
            },
            getFileExtension(filename)
            {
                var ext = /^.+\.([^.]+)$/.exec(filename);
                return ext == null ? "" : ext[1].toLowerCase();
            },
            async addCommentRequest(){
                try {
                    const sendMsgComment = new FormData()
                    // sendMsgComment.append('id', this.formCommentData.idJob)
                    sendMsgComment.append('message', this.formCommentData.Comment)
                    if(this.formCommentData.file !== null){
                        sendMsgComment.append('upload_file', this.formCommentData.file)
                    }else{
                        sendMsgComment.append('upload_file', null)
                    }
                    const resCreateMsg = await this.$http.post(`/ticket/msg/push/${this.formCommentData.idJob}/`, sendMsgComment,{
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if(resCreateMsg.status === 201){
                        this.formCommentData =  Object.assign({}, formComment)
                        // get
                            this.formCommentData.idJob = resCreateMsg.data.ticket
                            this.getMassegeComment(resCreateMsg.data.ticket)
                        // get
                    }else {
                        throw { resCreateMsg }
                    }
                } catch (error) {
                    this.errorMsgs.push({
                        timestamp: new Date().getTime(),
                        msg: error,
                    });
                    if (this.errorMsgs.length > 1) this.errorMsgs.shift()
                }
            },
            async addCloseTicket(){
                try {
                    // upstatust
                    const closeJob = await this.$http.patch(`/ticket/close/${this.formVoteData.idJob}/`, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if (closeJob.status === 200) {
                        // return true
                        this.addVoteTicket()
                    }
                } catch (error) {
                    return false
                }
            },
            async addVoteTicket(){
                try {
                    const sendVote = new FormData()
                    if(document.querySelector('input[name=rating]:checked') !== null){
                        sendVote.append('ticketcomment', this.formVoteData.suggestion)
                        sendVote.append('ticketpoint',document.querySelector('input[name=rating]:checked').value)
                    }else{
                        sendVote.append('ticketcomment', this.formVoteData.suggestion)
                        sendVote.append('ticketpoint',0)
                    }
                    // for (var value of sendVote.values()) {
                    //     console.log(value); 
                    // }
                    const resVote = await this.$http.patch(`/ticket/vote/${this.formVoteData.idJob}/`, sendVote,{
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if(resVote.status === 200){
                        this.formVoteData = Object.assign({}, formVote)
                        this.formUiVote = false
                        this.formUiComment = true
                        this.Staus = 'success'
                        this.ticketcomment = resVote.data.ticketcomment
                        this.ticketpoint = resVote.data.ticketpoint
                    }
                } catch (error) {}
            }
        }
    }
</script>